import { Directive, ElementRef, inject, input, OnChanges, OnInit, Renderer2, signal } from '@angular/core';

@Directive({
  selector: '[appBtnSpinner]',
})
export class BtnSpinnerDirective implements OnInit, OnChanges {
  private elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  public isLoading = input(false);
  private spinnerElement = signal<ElementRef | null>(null);
  private contentText!: string;

  public ngOnInit(): void {
    if (this.elementRef.nativeElement.textContent) {
      this.contentText = this.elementRef.nativeElement.textContent;
    }
    if (this.isLoading()) {
      this.showSpinner();
    } else {
      this.hideSpinner();
    }
  }

  public ngOnChanges(): void {
    if (this.isLoading()) {
      this.showSpinner();
    } else {
      this.hideSpinner();
    }
  }

  private showSpinner(): void {
    if (!this.spinnerElement()) {
      this.spinnerElement.set(this.renderer.createElement('span'));
      this.renderer.addClass(this.spinnerElement(), 'spinner-border');
      this.renderer.addClass(this.spinnerElement(), 'btn-spinner');
      this.renderer.setStyle(this.spinnerElement(), 'margin-left', '5px');
      this.renderer.appendChild(this.elementRef.nativeElement, this.spinnerElement());
    }
  }

  private hideSpinner(): void {
    if (this.spinnerElement()) {
      this.renderer.removeChild(this.elementRef.nativeElement, this.spinnerElement());
      this.spinnerElement.set(null);
    }
  }
}
